const VC = {
  /* ── State ── */
  state: {
    greeting: '', style: 'ink', custom: false,
    envelopeId: null, envelopePrice: 0, envelopeName: '',
    envelopeImg: '', qty: 1
  },

  /* ── Greeting preview ── */
  setGreeting(el, text) {
    document.querySelectorAll('.chips [data-greet]').forEach(c => c.classList.remove('on'));
    if (el) el.classList.add('on');
    this.state.greeting = text;
    this.state.custom = (text === '__custom__');
    const box = document.getElementById('custom-box');
    if (box) box.style.display = this.state.custom ? 'block' : 'none';
    this.renderGreeting(this.state.custom ? (document.getElementById('custom-input')?.value || '') : text);
    const lbl = document.getElementById('greet-current');
    if (lbl) lbl.textContent = this.state.custom ? 'Your own words' : (text || 'Blank');
  },
  onCustomType(val) { if (this.state.custom) this.renderGreeting(val); },
  renderGreeting(text) {
    const live = document.getElementById('greet-live'); if (!live) return;
    live.classList.add('fading');
    setTimeout(() => { live.textContent = (text === 'Blank' || !text) ? '' : text; live.classList.remove('fading'); }, 220);
  },
  setStyle(el, style) {
    document.querySelectorAll('.style-toggle button').forEach(b => b.classList.remove('on'));
    el.classList.add('on'); this.state.style = style;
    const live = document.getElementById('greet-live');
    if (live) live.classList.toggle('gold', style === 'gold');
    const lbl = document.getElementById('style-current');
    if (lbl) lbl.textContent = style === 'gold' ? 'Gold emboss' : 'Forest ink';
  },

  /* ── Envelope picker — real product images ── */
  pickEnvelope(el, variantId, priceCents) {
    document.querySelectorAll('.env-card').forEach(c => c.classList.remove('on'));
    el.classList.add('on');
    this.state.envelopeId   = variantId;
    this.state.envelopePrice = priceCents;

    const lbl   = document.getElementById('env-picker-label');
    const strip = document.getElementById('env-selected-strip');
    const extra = document.getElementById('pi-env-extra');

    if (!variantId) {
      if (lbl)   lbl.textContent = 'No envelope';
      if (strip) strip.style.display = 'none';
      if (extra) extra.style.display = 'none';
    } else {
      const name  = el.querySelector('.env-card-name')?.textContent || 'Envelope';
      const price = el.querySelector('.env-card-price')?.textContent || '';
      const img   = el.querySelector('img')?.src || '';
      this.state.envelopeName = name;
      this.state.envelopeImg  = img;
      if (lbl)   lbl.textContent = name + ' envelope selected';
      if (extra) { extra.textContent = '+ ' + price + ' (envelope)'; extra.style.display = 'inline'; }
      if (strip) {
        strip.style.display = 'grid';
        const si = document.getElementById('env-strip-img');
        const sn = document.getElementById('env-strip-name');
        const sp = document.getElementById('env-strip-price');
        if (si && img) { si.src = img; si.alt = name; } else if (si) { si.src = ''; }
        if (sn) sn.textContent = name + ' Envelope';
        if (sp) sp.textContent = price + ' added to order';
      }
    }
    this.updateCartTotal();
  },

  updateCartTotal() {
    const disp = document.getElementById('cart-total-display');
    const priceEl = document.getElementById('pi-price-val');
    if (!disp || !priceEl) return;
    const baseText = priceEl.textContent.replace(/[^0-9]/g,'');
    const base = parseInt(baseText) || 0;
    const envExtra = Math.round(this.state.envelopePrice / 100);
    const qty = this.state.qty || 1;
    if (envExtra > 0) {
      disp.textContent = '₹' + ((base + envExtra) * qty).toLocaleString('en-IN');
    } else {
      disp.textContent = '';
    }
  },

  /* ── Add to cart — adds card + envelope together ── */
  addToCart(e) {
    e.preventDefault();
    const vid = document.getElementById('selected-variant');
    if (!vid) return;

    const greetText = this.state.custom
      ? (document.getElementById('custom-input')?.value || '').trim()
      : this.state.greeting;
    const note = document.getElementById('gift-note')?.value?.trim() || '';

    const cardProps = {};
    if (greetText && greetText !== 'Blank') {
      cardProps['Greeting'] = greetText;
      cardProps['Greeting Style'] = this.state.style === 'gold' ? 'Gold emboss' : 'Forest ink';
    }
    if (note) cardProps['Gift Note'] = note;
    if (this.state.envelopeName) cardProps['Envelope'] = this.state.envelopeName;

    const qty = parseInt(document.getElementById('qty-input')?.value) || 1;

    /* Build items array — card always first, envelope second if chosen */
    const items = [{ id: parseInt(vid.value), quantity: qty, properties: cardProps }];

    if (this.state.envelopeId && typeof this.state.envelopeId === 'number') {
      items.push({
        id: this.state.envelopeId,
        quantity: qty,
        properties: { 'Paired with': document.querySelector('.pi-title')?.textContent?.trim() || 'Card' }
      });
    }

    const btn = document.getElementById('atc-btn');
    if (btn) { btn.textContent = 'Adding…'; btn.disabled = true; }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items })
    })
    .then(r => { if (!r.ok) throw new Error(); return r.json(); })
    .then(() => {
      if (btn) { btn.textContent = '✦ Added!'; }
      setTimeout(() => { if (btn) { btn.textContent = 'Add to Cart'; btn.disabled = false; } }, 2200);
      VC.openCart();
    })
    .catch(() => { if (btn) { btn.textContent = 'Add to Cart'; btn.disabled = false; } });
  },

  selectVariant(el, pos, val) {
    el.closest('.chips').querySelectorAll('.chip').forEach(b => b.classList.remove('on'));
    el.classList.add('on');
    if (!window._sel) window._sel = {};
    window._sel[pos] = val;
    if (window._variants) {
      const match = window._variants.find(v =>
        (!window._sel[1] || v.option1 === window._sel[1]) &&
        (!window._sel[2] || v.option2 === window._sel[2]) &&
        (!window._sel[3] || v.option3 === window._sel[3]));
      if (match) {
        const vid = document.getElementById('selected-variant');
        const price = document.getElementById('pi-price-val');
        if (vid) vid.value = match.id;
        if (price) price.textContent = VC.money(match.price);
        const btn = document.getElementById('atc-btn');
        if (btn) { btn.disabled = !match.available; btn.textContent = match.available ? 'Add to Cart' : 'Sold Out'; }
        if (match.featured_image?.src) {
          const main = document.getElementById('stage-img');
          if (main) main.src = match.featured_image.src;
        }
        this.updateCartTotal();
      }
    }
  },

  swapImage(el, src) {
    const main = document.getElementById('stage-img');
    if (main) main.src = src;
    document.querySelectorAll('.thumb').forEach(t => t.classList.remove('on'));
    el.classList.add('on');
  },

  qtyChange(delta) {
    const inp = document.getElementById('qty-input'); if (!inp) return;
    const v = Math.max(1, (parseInt(inp.value) || 1) + delta);
    inp.value = v; this.state.qty = v;
    this.updateCartTotal();
  },

  money(cents) {
    return '₹' + (cents / 100).toLocaleString('en-IN', { minimumFractionDigits: 0 });
  },

  /* ── Cart drawer ── */
  openCart() {
    const d = document.getElementById('drawer'); if (!d) return;
    d.classList.add('open'); d.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    this.loadCart();
  },
  closeCart() {
    const d = document.getElementById('drawer'); if (!d) return;
    d.classList.remove('open'); d.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  },
  loadCart() {
    fetch('/cart.js').then(r => r.json()).then(cart => {
      const body = document.getElementById('dw-body');
      const total = document.getElementById('dw-total');
      if (!body) return;
      if (!cart.items.length) {
        body.innerHTML = '<p style="font-size:12.5px;color:#8A8178;text-align:center;padding:48px 0;line-height:1.8;">Your cart is empty.<br><span style="font-family:\'Cormorant Garamond\',serif;font-style:italic;font-size:16px;color:#1A3328;">Every occasion deserves a card worth keeping.</span></p>';
        if (total) total.textContent = '';
        return;
      }
      body.innerHTML = cart.items.map(it => {
        const props = Object.entries(it.properties || {})
          .filter(([k,v]) => v && k.charAt(0) !== '_')
          .map(([k,v]) => `<span style="display:block">${k}: ${v}</span>`).join('');
        return `<div class="dw-item">
          <div class="dw-img">${it.image ? `<img src="${it.image}" alt="" loading="lazy">` : ''}</div>
          <div>
            <p class="dw-n">${it.product_title}</p>
            ${it.variant_title && it.variant_title !== 'Default Title' ? `<p class="dw-v">${it.variant_title}</p>` : ''}
            ${props ? `<p class="dw-v">${props}</p>` : ''}
            <p class="dw-p">${VC.money(it.final_line_price)}${it.quantity > 1 ? ` <span style="font-size:10px;color:#8A8178">× ${it.quantity}</span>` : ''}</p>
          </div>
        </div>`;
      }).join('');
      if (total) total.textContent = VC.money(cart.total_price);
      VC.badge(cart.item_count);
    }).catch(console.error);
  },
  badge(n) {
    let c = document.querySelector('.cart-count');
    if (n > 0) {
      if (!c) { c = document.createElement('span'); c.className = 'cart-count'; document.querySelector('.cart-btn')?.appendChild(c); }
      if (c) c.textContent = n;
    } else if (c) c.remove();
  },

  /* ── Homepage builder tabs ── */
  switchTab(id) {
    document.querySelectorAll('.tab').forEach(t => t.classList.toggle('on', t.dataset.tab === id));
    document.querySelectorAll('.tabc').forEach(c => c.classList.toggle('on', c.id === 'tc-' + id));
  },
  pickOpt(el, group, val) {
    el.closest('.optgrid').querySelectorAll('.opt').forEach(o => o.classList.remove('on'));
    el.classList.add('on');
    const p = document.getElementById('sel-' + group);
    if (p) p.textContent = val;
  },

  /* ── Accordions ── */
  acc(btn) { btn.closest('.acc-item').classList.toggle('open'); },

  /* ── Mobile nav ── */
  openMenu() {
    const n = document.getElementById('mnav'); if (!n) return;
    n.classList.add('open'); n.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  },
  closeMenu() {
    const n = document.getElementById('mnav'); if (!n) return;
    n.classList.remove('open'); n.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  },

  /* ── Hero greeting cycler ── */
  heroCycle() {
    const el = document.getElementById('mock-greet'); if (!el) return;
    const g = ['Happy Birthday','Shubh Vivah','With Deepest Sympathy','Thank You, Truly','Happy Raksha Bandhan','A Bright New Year','With Love, Always','Congratulations'];
    let i = 0;
    if (window.matchMedia('(prefers-reduced-motion:reduce)').matches) return;
    setInterval(() => {
      el.classList.add('fade');
      setTimeout(() => { i = (i + 1) % g.length; el.textContent = g[i]; el.classList.remove('fade'); }, 450);
    }, 3200);
  },

  /* ── Scroll reveal ── */
  reveals() {
    const els = document.querySelectorAll('.reveal');
    if (!('IntersectionObserver' in window)) { els.forEach(e => e.classList.add('in')); return; }
    const io = new IntersectionObserver(entries => {
      entries.forEach(en => { if (en.isIntersecting) { en.target.classList.add('in'); io.unobserve(en.target); } });
    }, { threshold: 0.12 });
    els.forEach(e => io.observe(e));
  },

  init() {
    fetch('/cart.js').then(r => r.json()).then(c => VC.badge(c.item_count)).catch(() => {});
    document.addEventListener('keydown', e => { if (e.key === 'Escape') { VC.closeCart(); VC.closeMenu(); } });
    this.heroCycle();
    this.reveals();
  }
};

document.addEventListener('DOMContentLoaded', () => VC.init());

/* ── Bundle builder footer visibility ── */
(function() {
  const footer = document.getElementById('bb-footer');
  const builder = document.getElementById('bundle-builder');
  if (!footer || !builder) return;
  const io = new IntersectionObserver(entries => {
    entries.forEach(en => footer.classList.toggle('visible', en.isIntersecting));
  }, { threshold: 0.05 });
  io.observe(builder);
})();
